module.exports = __webpack_public_path__ + "img/2lyf4d512yjq_o.f7f31895.png";